import { downloadFromBlobPromise } from '@bessemercws/utils';

export const fetchDownloadFromUrl = (url?: string, token?: string) => {
  if (!url || !token) return null;
  const headers = {
    authorization: token,
  };
  const result = fetch(url, {
    method: 'GET',
    headers,
  }).then(
    (response) => response.blob(),
    () => {
      console.error('failed to download');
      return null;
    },
  );
  const filenameParts = url.split('/');
  const filename = filenameParts[filenameParts.length - 1];
  if (result) {
    downloadFromBlobPromise(result, filename);
  }
};
